import {AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import {ActivatedRoute, NavigationEnd, Router, RouterEvent} from '@angular/router';
import {Subject, Subscription} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';
import {getRelativePath} from 'tslint/lib/configuration';

@Component({
  selector: 'app-admin-theme',
  templateUrl: './admin-theme.component.html',
  styleUrls: ['./admin-theme.component.scss']
})
export class AdminThemeComponent implements OnInit, AfterContentInit, OnDestroy, AfterViewInit {

  // region Atributos
  public hideBar = false;
  public readyData = false;
  public visible = true;

  public destroyed = new Subject<any>();
  public querySub: Subscription;
  @ViewChild('sidenav') sidenav: MatSidenav;
  // endregion

  isMobile: boolean;


  // region Constructor
  constructor(
    private router: Router,
    changeDetectorRef: ChangeDetectorRef,
  ) {
   }
  // endregion
  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   if (event.target.window.innerWidth <= 1024) {
  //     this.isMobile = true;
  //     this.sidenav.toggle(false);
  //     this.visible = true;
  //   } else {
  //     this.isMobile = false;
  //     this.visible = false;
  //     this.sidenav.toggle(true);
  //   }
  // }

  // region Métodos
  ngOnInit(): void {
    let currentRoute;
    this.querySub = this.router.events.pipe(
      filter((event: RouterEvent) => event instanceof NavigationEnd),
      takeUntil(this.destroyed)
    ).subscribe(() => {
      //this.sidebarDrw.toggle(true);
      currentRoute = this.router.url.replace('/', '');
      // switch (currentRoute) {
      //   case 'home':
      //     this.visible = false;
      //     this.sidebarDrw.toggle(false);
      //     break;
      //   default:
      //     this.visible = true;
      //     break;
      // }
    });
    currentRoute = this.router.url.replace('/', '');
    //this.sidebarDrw.toggle(true);
    // switch (currentRoute) {
    //   case 'home':
    //     this.visible = false;
    //     this.sidebarDrw.toggle(false);
    //     break;
    //   default:
    //     this.visible = true;
    //     break;
    // }

  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.

    // if (window.innerWidth <= 1024) {
    //   this.isMobile = true;
    //   this.sidenav.toggle(false);
    //   this.visible = true;
    // } else {
    //   this.isMobile = false;
    //   this.sidenav.toggle(true);
    //   this.visible = false;
    // }

  }

  // Función para darle una pausa y mostrar loader de la página
  ngAfterContentInit(): void {
    setTimeout(() => {
      this.readyData = true;
    }, 1500);



    // const ruta = this.route.url.replace('/', '');
    // switch (ruta) {
    //   case 'home':
    //     this.visible = false;
    //     break;
    //   default:
    //     this.visible = true;
    //     break;
    // }
  }
  ngOnDestroy() {
    this.destroyed.unsubscribe();
    this.querySub.unsubscribe();
  }

  close(reason: string) {
    this.sidenav.close();
  }

  // endregion
}
